import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Check } from 'lucide-react';
import { Button, CHECKOUT_URL } from '../ui/Button';
import { CountdownTimer } from '../ui/CountdownTimer';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/rMDE47mKX3dPeWQazKwAic/ChatGPT_Image_May_6,_2026,_01_01_17_AM.png';
export function Pricing() {
  return <section id="comprar" className="py-24 bg-brand-dark relative overflow-hidden" data-id="element-72">
      {/* subtle accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/5 rounded-full blur-3xl pointer-events-none" data-id="element-73" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-74">
        <div className="text-center mb-12" data-id="element-75">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-brand-green text-brand-dark text-xs font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-76">
            ⚡ OFERTA POR TIEMPO LIMITADO
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-3" data-id="element-77">
            Empezá tu camino al triatlón hoy
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-78">
            Acceso inmediato al sistema completo y a todas las herramientas
            exclusivas.
          </p>
        </div>

        {/* Countdown - dark variant */}
        <div className="max-w-md mx-auto mb-10" data-id="element-79">
          <CountdownTimer variant="dark" data-id="element-80" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl shadow-brand-green/10 border border-white/10 overflow-hidden" data-id="element-81">
          <div className="bg-brand-dark text-white text-center py-4" data-id="element-82">
            <p className="text-sm font-bold tracking-widest uppercase" data-id="element-83">
              <span className="text-brand-green" data-id="element-84">●</span> ACCESO INMEDIATO
            </p>
          </div>

          <div className="p-8 md:p-12 grid md:grid-cols-2 gap-10 items-center" data-id="element-85">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block group" data-id="element-86">
              <img src={PRODUCT_IMAGE} alt="Triatlón en 6HS" className="w-full max-w-sm mx-auto drop-shadow-xl group-hover:scale-[1.02] transition-transform" data-id="element-87" />
            </a>

            <div data-id="element-88">
              <h3 className="font-serif text-3xl font-bold text-brand-dark mb-6" data-id="element-89">
                Triatlón en 6HS — Sistema Completo
              </h3>

              <ul className="space-y-2 mb-8" data-id="element-90">
                {['Plan completo de Natación, Ciclismo y Running', 'Calculadoras de hidratación y proteínas', 'Guía de suplementos validados', 'Acceso inmediato y de por vida', 'Garantía de 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-91">
                    <Check size={18} className="text-brand-green-dark flex-shrink-0 mt-0.5" data-id="element-92" />
                    <span data-id="element-93">{f}</span>
                  </li>)}
              </ul>

              <div className="mb-2" data-id="element-94">
                <span className="text-slate-400 line-through text-xl" data-id="element-95">
                  $49.990
                </span>
              </div>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-96">
                <span className="font-serif text-5xl md:text-6xl font-bold text-brand-dark" data-id="element-97">
                  $19.990
                </span>
                <span className="text-slate-500 text-sm" data-id="element-98">ARS</span>
              </div>

              <Button href={CHECKOUT_URL} className="w-full px-6 py-5 text-lg mb-4" data-id="element-99">
                → QUIERO ENTRENAR TRIATLÓN SIN CAOS AHORA
              </Button>

              <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500 font-medium" data-id="element-100">
                <div className="flex items-center gap-1" data-id="element-101">
                  <ShieldCheck size={14} className="text-brand-green-dark" data-id="element-102" />
                  Garantía 7 días
                </div>
                <span className="text-slate-300" data-id="element-103">•</span>
                <div className="flex items-center gap-1" data-id="element-104">
                  <Lock size={14} className="text-brand-green-dark" data-id="element-105" />
                  Pago seguro
                </div>
                <span className="text-slate-300" data-id="element-106">•</span>
                <div className="flex items-center gap-1" data-id="element-107">
                  <CreditCard size={14} className="text-brand-green-dark" data-id="element-108" />
                  Mercado Pago
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}